// extracted by mini-css-extract-plugin
export var formContainer = "_bv-0";
export var message = "_bv-1";